import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import {
  Divider,
  Grid,
  HighlightContainer,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@qbe/ads-core';
import React from 'react';

import { useTrackOptimizeActivate } from '~/hooks/useTrackOptimizeActivate';
import { CoverItem } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

interface SelectedPortableItemProps {
  coverList: CoverItem[];
  onEdit: (item: CoverItem) => void;
  onDelete: (id: string) => void;
}

const SelectedPortableItem: React.FC<SelectedPortableItemProps> = ({
  coverList,
  onEdit,
  onDelete,
}) => {
  const theme = useTheme();

  // Tracks the "optimize.activate" event when the component mounts or re-renders.
  // This is used to notify Webtrends (or other analytics tools) for visibility tracking
  // and ensures dynamic content is properly handled.
  useTrackOptimizeActivate();

  return (
    <Stack spacing={2.5}>
      {coverList.length
        ? coverList.map((item) => (
            <HighlightContainer key={item.id}>
              <Grid container direction="row">
                <Grid item width="65%">
                  <Typography variant="subtitle2" component="h4" fontWeight="fontWeightMedium">
                    {item.category}
                  </Typography>
                  {item.description && <Typography>{item.description}</Typography>}
                  <Typography>{currencyFormatter(item.value, CurrencyFormat.Comma)}</Typography>
                </Grid>
                <Grid
                  item
                  width="35%"
                  display="flex"
                  gap={1.5}
                  justifyContent="flex-end"
                  alignItems="baseline"
                >
                  <IconButton
                    iconProps={{
                      muiIcon: EditIcon,
                      color: theme.palette.text.primary,
                    }}
                    onClick={() => onEdit(item)}
                    data-track="Edit cover"
                    name="edit"
                  />
                  <Divider
                    orientation="vertical"
                    sx={{
                      border: '1px solid divider',
                      height: '20px',
                      boxSizing: 'border-box',
                    }}
                  />
                  <IconButton
                    iconProps={{
                      muiIcon: ClearIcon,
                      color: theme.palette.text.primary,
                    }}
                    onClick={() => onDelete(item.id)}
                    data-track="Delete cover"
                    name="clear"
                  />
                </Grid>
              </Grid>
            </HighlightContainer>
          ))
        : null}
    </Stack>
  );
};

export default SelectedPortableItem;
